import * as THREE from "three";
import { createPointMarker } from "./PointMarker";
import { updatePolyLine } from "./UpdatePolyLine";
import { useRef } from "react";
import { cleanupEquipmentObjects } from "./PathRemove_Create";

const Z_OFFSET = 2.5;

export const createEventHandlers = (params) => {
  const {
    pathGenerateMode,
    obstacleMode,
    containerRef,
    viewer,
    // markers,
    // nodes,
    // edges,
    // ribbonMeshs,
    polyline,
    ribbonMesh,
    vehicleSpec,
    obstaclePoints,
    obstacleMarkers,
    setObstacleModal,
    setObstaclePoints,
    updateObstacle,
    setObstacleMarkers,
    setEachObstaclePoints,
    pathEditMode,
    setSelectedMarker,
    setIsDragging,
    selectedMarker,
    isDragging,
    obstacleInfoArray,
    setObstacleInfoArray,
    closedObstacleArea,
    setClosedObstacleArea,
    allObstaclePoints,
    setAllObstaclePoints,
    currentDraftingIdRef,
    selectedAreaColor,
    obstacleInfo,
    setObstacleInfo,
    selectedEquipmentId,
    equipmentPaths,
    updateEquipmentPath,
    showAllEquipmentMarkers,
    setPathGenerateMode,
    setPathEditMode,
    resetEquipmentPath,
    handleEquipmentPathReset,
  } = params;

  const currentPath = equipmentPaths[selectedEquipmentId] || {
    markers: [],
    nodes: [],
    edges: [],
    ribbonMeshs: [],
    polyline: null,
    ribbonMesh: null,
  };

  //클릭 이벤트 처리 ----------------------------------------------------------------
  const modeHandlers = {
    pathGenerate: (pointData) => {
      // 현재 선택된 장비 아이디
      const equipmentId = selectedEquipmentId;

      // 현재 선택된 장비의 경로 데이터
      const currentPath = equipmentPaths[equipmentId];

      // 포인트 마커 생성 및 추가
      const marker = createPointMarker(
        pointData,
        0xff00ff,
        0.5,
        currentDraftingIdRef.current,
        equipmentId,
        pathGenerateMode
      );
      viewer.scene.scene.add(marker);

      currentPath.markers.push(marker);
      currentPath.nodes.push(pointData.clone());

      // 배열에 마커 추가
      // markers.push(marker);
      // nodes.push(pointData.clone());

      const result = updatePolyLine(
        viewer,
        currentPath.polyline,
        currentPath.nodes,
        currentPath.ribbonMesh,
        vehicleSpec,
        {},
        currentPath.edges,
        currentPath.markers,
        currentPath.ribbonMeshs,
        false,
        equipmentId
      );
    },
    obstacle: (pointData) => {
      // currentDraftingIdRef: 현재 그리고 있는 장애물 영역의 고유 식별자
      // obstaclePoints: 현재 그리고 있는 장애물 하나의 좌표들

      if (obstaclePoints.length === 0 && !currentDraftingIdRef.current) {
        currentDraftingIdRef.current = Date.now(); // 장애물 영역 고유 식별자 생성
      }

      if (obstaclePoints.length > 0) {
        // 장애물 좌표가 있을 때 장애물 완성
        const firstPoint = obstaclePoints[0];
        const distance = pointData.distanceTo(firstPoint); // 시작점과의 거리 계산(m 단위)

        // 시작점과의 거리가 2m 이하일 때 장애물 완성
        if (distance < 2) {
          const closedPoints = [...obstaclePoints, firstPoint]; // 장애물 좌표 완성
          const { lines, polygons, all } = updateObstacle(
            viewer,
            closedPoints,
            currentDraftingIdRef.current,
            selectedAreaColor
          ); // 장애물 생성

          setClosedObstacleArea([...closedObstacleArea, closedPoints]); // 모든 완성된 장애물 좌표들을 저장

          // 현재 값들을 복사해서 사용
          const currentPoints = [...obstaclePoints];
          const currentMarkers = [...obstacleMarkers]; // 장애물 마커 객체들

          setEachObstaclePoints({
            points: currentPoints, // 좌표 배열
            markers: currentMarkers, // 마커 객체들
            lines,
            polygons,
            all,
            id: currentDraftingIdRef.current, // 장애물 영역 고유 식별자
          });

          // obstacleMarkers.forEach((marker) => {
          //   marker.material.visible = false; // 장애물 마커 숨기기
          // });

          setObstaclePoints([]); // 장애물 좌표 초기화
          setObstacleMarkers([]); // 장애물 마커 초기화

          setObstacleModal(true); // 장애물 모달 표시
          setObstacleInfo(currentDraftingIdRef.current);

          currentDraftingIdRef.current = null;
          return;
        }
      }
      // 장애물 추가 모드일 때 마커 생성
      const marker = createPointMarker(
        pointData,
        obstaclePoints.length === 0 ? 0x00ff00 : selectedAreaColor,
        0.5,
        currentDraftingIdRef.current,
        selectedEquipmentId
      );
      viewer.scene.scene.add(marker); // 마커 추가

      obstaclePoints.push(pointData); // 하나의 장애물 좌표 추가
      obstacleMarkers.push(marker); // 하나의 장애물 마커 추가

      const renderObjects = updateObstacle(
        viewer,
        obstaclePoints,
        currentDraftingIdRef.current,
        selectedAreaColor
      ); // 장애물 업데이트
    },
  };

  const cancleCurrentObstacle = () => {
    if (currentDraftingIdRef.current) {
      const toRemove = [];
      // 지금 생성중인 같은 아이디를 가진 제거 객체들을 찾아서 제거
      viewer.scene.scene.traverse((obj) => {
        if (obj.userData?.obstacleId === currentDraftingIdRef.current) {
          toRemove.push(obj);
        }
        if (obj.userData?.markerId === currentDraftingIdRef.current) {
          toRemove.push(obj);
        }
      });

      toRemove.forEach((obj) => {
        viewer.scene.scene.remove(obj);
        if (obj.geometry) obj.geometry.dispose();
        if (obj.material) obj.material.dispose();
      });
    }

    setObstaclePoints([]);
    setObstacleMarkers([]);
    currentDraftingIdRef.current = null;
  };

  // 마우스 클릭 시 포인트 좌표 추출
  const getPointFromClick = (event) => {
    // 경로 생성 모드가 아니면 반환
    // 장애물 추가 모드가 아니면 반환
    if (!pathGenerateMode && !obstacleMode) {
      return;
    }

    event.stopPropagation();

    const mouse = new THREE.Vector2(
      // event.client : 좌상단 0, 0 -> 우하단 1920, 1080
      // containerRef.current.clientWidth : 1920
      // 마우스 클릭 좌표 > 정규화된 좌표로 변환 (-1 ~ 1)
      (event.clientX / containerRef.current.clientWidth) * 2 - 1,
      -(event.clientY / containerRef.current.clientHeight) * 2 + 1
    );

    const raycaster = new THREE.Raycaster();

    // 마우스 좌표와 현재 카메라 정보를 토대로 3차원에서 광선(ray)을 쏜다.
    // 광선과 3D 오브젝트가 어디서 만나는지를 계산해서 위치좌표를 반환한다.
    raycaster.setFromCamera(mouse, viewer.scene.getActiveCamera());
    // 첫번째 포인트 클라우드 가져오기
    const pointcloud = viewer.scene.pointclouds[0];
    // 레이와 객체들의 교차점을 찾는 기능을 사용해서 클릭한 포인트의 좌표를 가져온다.
    const intersects = raycaster.intersectObject(pointcloud, true);

    if (intersects.length < 1) return;

    const pt = intersects[0].point;

    // 포인트 클라우드 좌표 추출
    return new THREE.Vector3(pt.x, pt.y, pt.z + Z_OFFSET);
  };

  // 경로 생성 모드일 때만 클릭 이벤트 처리
  const handleClick = (event) => {
    const pointData = getPointFromClick(event);
    if (!pointData) return;

    if (pathGenerateMode) {
      modeHandlers.pathGenerate(pointData);
    } else if (obstacleMode) {
      modeHandlers.obstacle(pointData);
    }
  };
  //클릭 이벤트 처리 종료 ----------------------------------------------------------------

  // 수정 모드일 때만 클릭 이벤트 처리
  // 마우스 다운 이벤트 처리

  const handleMouseDown = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!pathEditMode) return;

    const mouse = new THREE.Vector2(
      (event.clientX / containerRef.current.clientWidth) * 2 - 1,
      -(event.clientY / containerRef.current.clientHeight) * 2 + 1
    );

    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, viewer.scene.getActiveCamera());

    // 마커 클릭 이벤트 처리
    const markerIntersects = raycaster.intersectObjects(
      currentPath.markers,
      true
    );

    if (markerIntersects.length > 0) {
      // 카메라 업데이트 완전 중단
      if (viewer.controls) {
        viewer.controls.enabled = false;
        // 카메라 업데이트 함수들을 비활성화
        viewer.controls.update = () => {}; // 빈 함수로 덮어쓰기
      }

      if (viewer.scene.controls) {
        viewer.scene.controls.enabled = false;
        viewer.scene.controls.update = () => {};
      }

      if (viewer.scene.orbitControls) {
        viewer.scene.orbitControls.enabled = false;
        viewer.scene.orbitControls.update = () => {};
      }
      const clickedMarker = markerIntersects[0].object;
      const markerIndex = currentPath.markers.indexOf(clickedMarker);

      setSelectedMarker(markerIndex);

      setIsDragging(true);
      currentPath.markers.forEach((marker) => {
        marker.material.color.setHex(0x00ff00); //  초록색
      });
      clickedMarker.material.color.setHex(0xff0000); //  빨간색
    } else {
      // 포인트 클라우드 클릭 이벤트 처리
      const pointcloud = viewer.scene.pointclouds[0];
      const intersects = raycaster.intersectObject(pointcloud, true);

      // 허공 클릭해서 좌표를 못찾는 경우 반환
      if (intersects.length === 0 || !intersects[0]?.point) {
        return;
      }

      const pt = intersects[0].point;
      const pointData = new THREE.Vector3(pt.x, pt.y, pt.z + Z_OFFSET);

      const pathCheck = isPointOnPath(pointData, currentPath.nodes);

      if (pathCheck.isValid) {
        // 경로 위에 클릭한 경우 - 중간에 삽입
        const insertIndex = pathCheck.insertIndex;

        // 마커 생성 및 중간에 삽입
        const marker = createPointMarker(
          pointData,
          0xff00ff,
          0.5,
          currentDraftingIdRef.current, // 장애물 영역 고유 식별자
          selectedEquipmentId,
          true // 포인트 마커로 생성
        );
        viewer.scene.scene.add(marker);
        currentPath.markers.splice(insertIndex, 0, marker);
        currentPath.nodes.splice(insertIndex, 0, pointData.clone());

        // showAllEquipmentMarkers();

        // 씬 정리 후 전체 재생성
        cleanupSceneObjects(viewer, selectedEquipmentId);

        // handleEquipmentPathReset(
        //   viewer,
        //   setPathGenerateMode,
        //   setPathEditMode,
        //   resetEquipmentPath,
        //   selectedEquipmentId
        // );

        // 클리어 후 경로 재생성

        const result = updatePolyLine(
          viewer,
          currentPath.polyline,
          currentPath.nodes,
          currentPath.ribbonMesh,
          vehicleSpec,
          {},
          currentPath.edges,
          currentPath.markers,
          currentPath.ribbonMeshs,
          false,
          selectedEquipmentId
        );

        const updatedRenderObjects = [];
        for (let i = 0; i < closedObstacleArea.length; i++) {
          const newRenderObjects = updateObstacle(
            viewer,
            closedObstacleArea[i],
            selectedAreaColor
          );
          updatedRenderObjects.push(newRenderObjects);
        }
      }
    }
  };

  // 마우스 모션 이벤트 처리
  const handleMouseMove = (event) => {
    if (!pathEditMode || selectedMarker === null || !isDragging) return;

    if (viewer.controls) {
      viewer.controls.panDelta.set(0, 0);
      viewer.controls.pitchDelta = 0;
      viewer.controls.yawDelta = 0;
      viewer.controls.radiusDelta = 0;
    }

    // 마우스 위치를 3D 좌표로 변환
    const mouse = new THREE.Vector2(
      (event.clientX / containerRef.current.clientWidth) * 2 - 1,
      -(event.clientY / containerRef.current.clientHeight) * 2 + 1
    );

    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, viewer.scene.getActiveCamera());

    // 포인트 클라우드와의 교차점으로 새 위치 계산
    const pointcloud = viewer.scene.pointclouds[0];
    const intersects = raycaster.intersectObject(pointcloud, true);

    if (intersects.length > 0) {
      const newPosition = new THREE.Vector3(
        intersects[0].point.x,
        intersects[0].point.y,
        intersects[0].point.z + Z_OFFSET
      );

      // 마커 위치 업데이트
      currentPath.markers[selectedMarker].position.copy(newPosition);
      currentPath.nodes[selectedMarker].copy(newPosition);

      updatePolyLine(
        viewer,
        currentPath.polyline,
        currentPath.nodes,
        currentPath.ribbonMesh,
        vehicleSpec,
        {},
        currentPath.edges,
        currentPath.markers,
        currentPath.ribbonMeshs,
        pathEditMode,
        isDragging,
        selectedMarker
      );
    }
  };

  // 마우스 업 이벤트 처리
  const handleMouseUp = (event) => {
    if (!pathEditMode || selectedMarker === null) return;

    // 카메라 업데이트 함수들 복원
    if (viewer.controls) {
      viewer.controls.enabled = true;
      // 원래 update 함수 복원 (Potree가 자동으로 복원)
      delete viewer.controls.update;
    }

    if (viewer.scene.controls) {
      viewer.scene.controls.enabled = true;
      delete viewer.scene.controls.update;
    }

    if (viewer.scene.orbitControls) {
      viewer.scene.orbitControls.enabled = true;
      delete viewer.scene.orbitControls.update;
    }

    // setSelectedMarker(null);
    setIsDragging(false);
  };

  const handleKeyDown = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (event.key === "Delete" && selectedMarker !== null) {
      const MarkerIndex = selectedMarker; // 선택한 마커

      const isLastPoint = MarkerIndex === currentPath.markers.length - 1; // 마지막 마커인지 확인
      const isFirstPoint = MarkerIndex === 0; // 첫번째 마커인지 확인

      if (currentPath.markers.length > 1) {
        const markerToRemove = currentPath.markers[MarkerIndex]; // 삭제할 마커
        viewer.scene.scene.remove(markerToRemove); // 마커 삭제
        markerToRemove.geometry.dispose(); // 마커 기하 제거
        markerToRemove.material.dispose(); // 마커 재료 제거

        currentPath.markers.splice(MarkerIndex, 1); // 마커 배열에서 삭제
        currentPath.nodes.splice(MarkerIndex, 1); // 노드 배열에서 삭제

        cleanupSceneObjects(viewer, selectedEquipmentId);

        updatePolyLine(
          viewer,
          currentPath.polyline,
          currentPath.nodes,
          currentPath.ribbonMesh,
          vehicleSpec,
          {},
          currentPath.edges,
          currentPath.markers,
          currentPath.ribbonMeshs,
          false,
          selectedEquipmentId
        );

        for (let i = 0; i < closedObstacleArea.length; i++) {
          updateObstacle(
            viewer,
            closedObstacleArea[i],
            selectedAreaColor
          );
        }
      }
    }
  };

  // 씬 오브젝트 정리 함수
  const cleanupSceneObjects = (viewer, selectedEquipmentId) => {
    const childrenToRemove = [];

    // 씬의 모든 자식들을 스캔
    viewer?.scene.scene.traverse((child) => {
      if (
        child.userData &&
        +child.userData.equipmentId === +selectedEquipmentId && // 농기구 ID로 필터링
        (child.userData.type === "path-line" ||
          child.userData.type === "final-line" ||
          child.userData.type === "temp-line" ||
          child.userData.type === "path-ribbon")
      ) {
        childrenToRemove.push(child);
      }
    });

    // 찾은 오브젝트들 제거
    childrenToRemove.forEach((child) => {
      if (child.geometry) child.geometry.dispose();
      if (child.material) child.material.dispose();
      // if (child.marker) child.marker.dispose();
      viewer.scene.scene.remove(child);
    });

    return childrenToRemove.length;
  };

  const isPointOnPath = (clickPoint, nodes, threshold = 1.0) => {
    for (let i = 0; i < nodes.length - 1; i++) {
      const start = nodes[i];
      const end = nodes[i + 1];

      // 선분에서 점까지의 수직 거리 계산
      const distance = distanceToSegment(clickPoint, start, end);

      // 1미터 반경 내에 있는지 확인
      if (distance <= threshold) {
        return {
          isValid: true,
          segmentIndex: i,
          insertIndex: i + 1,
          distance: distance,
        };
      }
    }

    return { isValid: false };
  };

  // 선분에서 점까지의 수직 거리 계산 함수
  const distanceToSegment = (point, segmentStart, segmentEnd) => {
    const A = point.x - segmentStart.x;
    const B = point.y - segmentStart.y;
    const C = segmentEnd.x - segmentStart.x;
    const D = segmentEnd.y - segmentStart.y;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;

    if (lenSq === 0) return point.distanceTo(segmentStart);

    let param = dot / lenSq;

    let xx, yy;
    if (param < 0) {
      // 점이 선분의 시작점보다 앞에 있음
      xx = segmentStart.x;
      yy = segmentStart.y;
    } else if (param > 1) {
      // 점이 선분의 끝점보다 뒤에 있음
      xx = segmentEnd.x;
      yy = segmentEnd.y;
    } else {
      // 점이 선분 위에 있음 (수직 투영)
      xx = segmentStart.x + param * C;
      yy = segmentStart.y + param * D;
    }

    const dx = point.x - xx;
    const dy = point.y - yy;
    return Math.sqrt(dx * dx + dy * dy);
  };

  return {
    handleClick,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    handleKeyDown,
    cleanupSceneObjects,
    cancleCurrentObstacle,
  };
};
